import { v4 as uuidv4 } from 'uuid';
import { Form } from '../domain';

export function correctForm(form: Form): Form {
	if (!form.formSchema) {
		return form;
	}
	if (!form.formSchema.sections) {
		return form;
	}

	form.formSchema.sections.forEach((section) => {
		if (!section.id) {
			section.id = uuidv4();
		}
		if (!section.fields) {
			section.fields = [];
		}
		section.fields.forEach((field) => {
			if (!field.id) {
				field.id = uuidv4();
			}
		});
	});
	return form;
}
